// extracted by mini-css-extract-plugin
export var divider = "_2v-0";
export var dividerText = "_2v-1";